<h1>Database tables sizes</h1>
GPS Log records: {{result.nGPSlogs}}<br>
Beacon Log records: {{result.nBeaconlogs}}<br>
Log records: {{result.nLogs}}<br>
